import { render } from "./Palette.vue?vue&type=template&id=60d965a2"
import script from "./Palette.vue?vue&type=script&lang=js"
export * from "./Palette.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__